// extracted by mini-css-extract-plugin
export var form = "_ek-0";